// All values are art pixels. No browser layout or screen-pixel rounding.
export interface Size { w: number; h: number }
/** align: the item's own cross-axis alignment (alignSelf), overriding the container's. */
export interface LayoutItem extends Size { grow: number; minW: number; minH: number; align?: string }
export function clamp(v: number, lo: number, hi: number): number { return Math.max(lo, Math.min(Math.max(lo, hi), v)); }
export function flex(items: LayoutItem[], width: number, height: number, row: boolean, gap: number,
  align = 'stretch', justify = 'start'): { x: number; y: number; w: number; h: number }[] {
  const main = row ? width : height, cross = row ? height : width;
  const sum = items.reduce((n, i) => n + (row ? i.w : i.h), 0) + Math.max(0, items.length - 1) * gap;
  const extra = Math.max(0, main - sum), shortage = Math.max(0, sum - main);
  const grows = items.reduce((n, i) => n + i.grow, 0);
  const shrinkable = items.reduce((n, i) => n + Math.max(0, (row ? i.w - i.minW : i.h - i.minH)), 0);
  // Flex growth consumes free space before justification (never allocate it twice).
  const remaining = grows ? 0 : extra;
  let cursor = justify === 'center' ? remaining / 2 : justify.includes('end') ? remaining : 0;
  const spacing = justify === 'space-between' && items.length > 1 ? gap + remaining / (items.length - 1) : gap;
  return items.map(i => {
    const preferred = row ? i.w : i.h, minimum = row ? i.minW : i.minH;
    const extent = Math.max(minimum, preferred + (grows ? extra * i.grow / grows : 0)
      - (shrinkable ? shortage * Math.max(0, preferred - minimum) / shrinkable : 0));
    const a = i.align ?? align;
    const c = a === 'stretch' ? cross : Math.min(cross, row ? i.h : i.w);
    const offset = a === 'center' ? (cross - c) / 2 : a.includes('end') ? cross - c : 0;
    const rect = row ? { x: cursor, y: offset, w: extent, h: c } : { x: offset, y: cursor, w: c, h: extent };
    cursor += extent + spacing;
    return rect;
  });
}
